export const DEFAULT_MESSAGES = {
  ASSET_SMART_SOURCE_TAB:
    "Enter Keywords above to start finding SmartSourced content for this digest. You can save your keywords and everytime you open this tab, we’ll present you with new timely content that meets your criteria!",
  ASSET_DASHBOARD_TAB: "",
  ASSET_PREVIOUSLY_SENT_TAB:
    "You haven’t sent this Digest to anyone yet, once you do, the content you sent out will be listed here so you can see it and curate it to other emails easily…",
  ASSET_AUDIENCE_TAB:
    "You haven’t added any people or lists to this email yet. Once you do, any time you publish, any contacts and lists added will receive the new edition automatically",
};

export const ALERT_MESSAGES = {
  DEFAULT_EMAIL_WITHOUT_CAMPAIGN: "All Emails need to be associated with a campaign before you can publish",
  WORKFLOW_EMAILS_ACTION: `Only the emails with the sender emails address will be showing below. i.e. "Send From: xyz@xiq.com"
  Please note that emails added to the workflow will no longer be editable.`,
};

export const CONTENT_MY_ACCOUNTS = {
  SALES_TRIGGERS: "Sales Triggers",
  SALES_TRIGGERS_DESCRIPTION: `Showing content relevant to all accounts. Select one or more accounts to refine the content
  below`,
};
